import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Flex } from "antd";

import { Button } from "@av/components/atoms/Button";
import { Image } from "@av/components/atoms/Image";
import { Typography } from "@av/components/atoms/typography/Typography";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

type forbiddenErrorPageProps = {
  handleGoToAppDashboard?: () => void;
};

function ForbiddenErrorPage(props: forbiddenErrorPageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleGoToAppDashboard } = props;

  useDocumentTitle(t("common.components.errors_forbidden_title"));

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToDashboard = () => {
    navigate("/");
  };

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap="middle"
      style={{
        minHeight: "75vh",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <Image
        testIdPrefix="forbidden"
        src="/errors/403_forbidden.png"
        alt={t("common.components.errors_forbidden_alt")}
        preview={false}
        style={{ maxWidth: "400px", maxHeight: "360px" }}
      />
      <Typography.Title
        testIdPrefix="forbidden"
        level={1}
        style={{ marginTop: 0, marginBottom: 8 }}
      >
        {t("common.components.errors_forbidden_title")}
      </Typography.Title>
      <Typography.Paragraph testIdPrefix="forbidden-message" type="secondary">
        {t("common.components.errors_forbidden_message")}
      </Typography.Paragraph>
      <Flex gap="small">
        <Button
          testIdPrefix="forbidden-go-back"
          onClick={handleGoBack}
          icon={<ArrowLeftOutlined />}
        >
          {t("common.components.errors_forbidden_goBack")}
        </Button>
        <Button
          testIdPrefix="forbidden-go-to-dashboard"
          type="primary"
          onClick={handleGoToAppDashboard ?? handleGoToDashboard}
        >
          {t("common.components.errors_forbidden_goToDashboard")}
        </Button>
      </Flex>
    </Flex>
  );
}

export { ForbiddenErrorPage };
